import BootstrapOffcanvas from "react-bootstrap/Offcanvas";
import Link from "@components/core/LinkApp";
import Image from "../Image";
import CloseButton from "../CloseButton";
import Button from "../Button";

function OffcanvasHeader({ title, closeButton, onHide, onGoBack, goBackButton }) {
  return (
    <BootstrapOffcanvas.Header>
      {goBackButton ? (
        <Button
          variant="ghost-dark"
          leftIconName="chevron-left"
          onClick={onGoBack}
        />
      ) : (
        <div className="p-3 m-1" />
      )}

      {title ? (
        <p className="text-center mb-0">{title}</p>
      ) : (
        <Link href="/home">
          <Image
            src="logo"
            alt="logo"
            style={{ height: "16px" }}
          />
        </Link>
      )}

      {closeButton && <CloseButton onClick={onHide} />}
    </BootstrapOffcanvas.Header>
  );
}

export default OffcanvasHeader;
